import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";

import Paging from "components/common/paging";
import ParkingSpotItem from './parkingSpotItem';

const ParkingSpotsTable = ({ parkingSpots, setParkingSpots, setShowEditParkingSpotModal, setParkingSpotToEdit }) => {

    const [parkingSpotPages, setParkingSpotPages] = useState();
    const [currentParkingSpotPage, setCurrentParkingSpotPage] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        if (parkingSpots) {
            setParkingSpotPages(Math.ceil(parkingSpots.length / 10));
        }
    }, [parkingSpots]);

    if (!parkingSpots) {
        return (null);
    }

    // O6: synkroniserad sortering med Objekt-id-skärmen — numrerade först,
    // numerisk-medveten på spotIdentifier (1, 2, ..., 15 inte 1, 10, 11, ..., 2)
    const sortedSpots = [...parkingSpots].sort((a, b) => {
        if ((a.isNumbered ? 1 : 0) !== (b.isNumbered ? 1 : 0)) {
            return (b.isNumbered ? 1 : 0) - (a.isNumbered ? 1 : 0);
        }
        return (a.spotIdentifier || '').localeCompare(
            b.spotIdentifier || '',
            'sv',
            { numeric: true, sensitivity: 'base' }
        );
    });

    return (
        <>
            <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                <table className="table-auto w-full">
                    <thead>
                        <tr className="text-left bg-airpark-gray-300 h-11">
                            <th className="pl-6">{t('parkingArea.id')}</th>
                            <th className="pl-6">{t('parkingArea.objectId')}</th>
                            <th className="pl-6">{t('parkingArea.locationSpecific')}</th>
                            <th className="pl-6">{t('parkingArea.floor')}</th>
                            <th className="pl-6">{t('parkingArea.number')}</th>
                            <th className="pl-6">{t('parkingArea.features')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedSpots.slice(currentParkingSpotPage * 10, ((currentParkingSpotPage * 10) + 10)).map((ps, i) => {
                            return (<ParkingSpotItem
                                key={i} parkingSpot={ps}
                                parkingSpots={parkingSpots}
                                setParkingSpots={setParkingSpots}
                                setShowEditParkingSpotModal={setShowEditParkingSpotModal}
                                setParkingSpotToEdit={setParkingSpotToEdit} />)
                        })}
                    </tbody>
                </table>
            </div>
            {parkingSpotPages > 0 &&
                <Paging totalNumberOfPages={parkingSpotPages} currentPage={currentParkingSpotPage} setCurrentPage={setCurrentParkingSpotPage} />
            }
        </>
    );
};

export default ParkingSpotsTable;